<template>
    <div class="hover-zoom-image">
        <router-link
            v-if="prod_type_id == 'tshirt24' || tshirt24hour"
            :event="whateverActivatesThisLink ? 'click' : ''"
            :to="{ path: '/24hourtshirts/' + product.id }"
        >
            <img
                style="width: 183px; height: 286px"
                :style="'background-color:' + backgroundColorHex + ';'"
                v-if="hasImage"
                :src="productImage(product.NewProductImages)"
                alt=" "
                :class="classValue"
            />
            <video
                v-else-if="product.video_url"
                :src="productImage(product.NewProductImages)"
                alt=" "
                :class="classValue"
            ></video>
        </router-link>
        <router-link
            v-else
            :event="whateverActivatesThisLink ? 'click' : ''"
            :to="{ path: '/product-details/' + product.id }"
        >
            <img
                v-if="hasImage"
                :style="'background-color:' + backgroundColorHex + ';'"
                :src="productImage(product.NewProductImages)"
                alt=" "
                :class="classValue"
            />
            <video
                v-else-if="product.video_url"
                :src="productImage(product.NewProductImages)"
                alt=" "
                :class="classValue"
            ></video>
        </router-link>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Productoffer",
    /* eslint-enable */
    data() {
        return {
            hasImage: true,
            prod_type_id: this.$route.params.product_type
        };
    },
    props: {
        whateverActivatesThisLink: {
            type: Boolean,
            default: true
        },
        product: {
            required: true
        },
        classValue: {
            type: String
        },
        color: {
            required: false,
            default: null
        },
        backgroundColorHex: {
            type: String
        },
        designImage: {
            required: false,
            default: null
        },
        colorProductImage: {
            required: false,
            default: null
        },
        tshirt24hour: {
            default: false
        }
    },

    methods: {
        productImage(images = []) {
            var _this = this;
            if (_this.designImage) {
                return _this.designImage;
            } else if (this.colorProductImage) {
                return this.colorProductImage;
            }
            let product_images = images.filter(
                (element) => element.color_id == this.color
            );
            if (product_images.length == 0) {
                product_images = images.filter(
                    (element) => element.color_id == null
                );
            }
            _this.hasImage = product_images.length > 0;
            if (_this.hasImage) {
                let image_path = product_images[0].medium
                    ? product_images[0].medium
                    : product_images[0].url;
                return product_images[0]
                    ? image_path
                    : "/maincss/images/featured_product_1.png";
            }
            return images[0]
                ? images[0].medium
                : "/maincss/images/featured_product_1.png";
        }
    }
};
</script>
